module.exports = __webpack_public_path__ + "img/complaints.833ef596.gif";